module.exports = __webpack_public_path__ + "static/LRCC-campaign-6fd6fc77ebc5e383aad0520961583ee6.jpg";